<ng-container *ngIf="(inputConfig$ | async) as inputConfig" [formGroup]="(formService.formGroup$ | async)!">
  <div class="flex">
    <ntap-dynamic [compId]="compId" [inputParam]="inputParam" class="flex-1 flex"></ntap-dynamic>
    <div class="flex align-content-center inherit-attr-check pl-1" *ngIf="formControlInheritable">
      &nbsp;
      <p-checkbox
        [formControlName]="inheritedAttrsFormControlName"
        [inputId]="'attribute' + attrId"
        [value]="attrId"
        [readonly]="readOnly"
        [disabled]="readOnly"
      ></p-checkbox>
      &nbsp;
      <span class="m-auto">{{ inheritanceLabel }}</span>
    </div>
  </div>
</ng-container>